// @flow

import ApiObject from './ApiObject';
import ApiConstants from '../constants/ApiConstants';
import DateUtils from '../utils/DateUtils';

export default class Payment extends ApiObject {

  static Type = {
    EVERYTHING: 1,

    EQUAL_SHARE: 2,

    SPECIFIC_AMOUNT: 3,

    SELECT_ITEMS: 4,

    DISTANT_PAYMENT: 5,

    PAYMENT_WITH_ORDER: 6
  };

  static Status = {
    CREATED: 'CREATED',
    PAID: 'PAID',
    FAILED: 'FAILED',
    REFUNDED: 'REFUNDED'
  }

  id: string = '';

  cardId: string = '';

  amount: number = 0;

  tip: number = 0;

  credit: number = 0;

  type: number = 0;

  checkId: string = '';

  credit: number = 0;

  // TODO: set default to '' after api changement.
  currency: string = null;

  date: number = 0;

  fees: number = 0;

  payIn3DSecureUrl: string = '';

  payInId: string = '';

  payInIdPmt: string = '';

  payInRefundId: string = '';

  restId: string = '';

  restaurantName: string = '';

  sDate: number = 0;

  sNumTicket: string = '';

  status: string = Payment.Status.CREATED;

  tips: number = 0;

  transferIdPmt: string = '';

  transferRefundIdPmt: string = '';

  userId: string = '';

  /**
   * TODO
   * For now front only for acrelec sdk
   * A transaction identifier value used for a futher payment matching (bank or debug purposes)
   */
  reference: string = '';

  getFormattedDate(format: string = 'DD/MM/Y'): string {
    return DateUtils.fromSecondsTimestampToString(this.date, format);
  }

  getFormattedHour(format: string = 'HH:mm'): string {
    return DateUtils.fromSecondsTimestampToString(this.date, format);
  }

  postJsonAssignation(data: Object) {
    this.date = Math.floor(this.date / 1000);
    this.tip = this.tips;
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/Payment.js